import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import messages from './local/index';

// Detect language synchronously from URL BEFORE first render
// Root "/" redirects to "/es", so default is always Spanish
const initialLang = window.location.pathname.startsWith('/en') ? 'en' : 'es';

i18n
  .use(initReactI18next)
  .init({
    lng: initialLang,
    fallbackLng: 'es',
    debug: false,
    showSupportNotice: false,
    resources: messages,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
